define((require, exports, module) => {
    'use strict';

    const UploadReason = require('../UploadReason');
    const BrowserFileSizeLimitFail = require('../fails/BrowserFileSizeLimitFail');

    const GB = 1024 * 1024 * 1024;

    /**
     * @namespace
     */
    const env = {
        /**
         * IE10 и IE11 не поддерживают загрузку файлов размером больше 4GB.
         * @url https://blogs.msdn.microsoft.com/ieinternals/2011/03/10/file-upload-and-download-limits/
         * @type {number}
         */
        MAX_TRIDENT_FILE_SIZE: 4 * GB,

        /**
         * Сведений о максимальном размере загружаемого файла в Edge не нашлось,
         * но выполнить загрузку файла больше 4GB не удалось,
         * а при попытке создать инстанс FormData больше 4GB
         * возникает ошибка: "Arithmetic result exceeded 32 bits".
         * @type {number}
         */
        MAX_EDGE_FILE_SIZE: 4 * GB,

        /**
         * @type {boolean}
         */
        isMacOS: navigator.platform === 'MacIntel',

        /**
         * @type {boolean}
         */
        isTrident: navigator.userAgent.indexOf('Trident/') !== -1,

        /**
         * @type {boolean}
         */
        isEdge: navigator.userAgent.indexOf('Edge/') !== -1,

        /**
         * @type {boolean}
         */
        isFirefox: navigator.userAgent.indexOf('Firefox/') !== -1,

        /**
         * @param {number} size – in bytes
         * @returns {Promise}
         * @resolves {number} – size
         * @rejects {UploadReason|Error}
         */
        checkFileSizeLessThanBrowserLimit(size) {
            let promise;

            if (
                (env.isTrident && size > env.MAX_TRIDENT_FILE_SIZE) ||
                (env.isEdge && size > env.MAX_EDGE_FILE_SIZE)
            ) {
                const source = UploadReason.SOURCE_WEB_CLIENT;
                const stack = new Error('BrowserFileSizeLimitFail');
                const reason = new BrowserFileSizeLimitFail(stack, source);

                promise = Promise.reject(reason);
            } else {
                promise = Promise.resolve(size);
            }

            return promise;
        },

        /**
         * @param {number} size – in bytes
         * @returns {Promise}
         * @resolves {number} – size
         * @rejects {UploadReason|Error}
         */
        checkFileSizeLessThanLimit(size) {
            return env.checkFileSizeLessThanBrowserLimit(size);
        },
    };

    module.exports = env;
});
